import useReturnPathStore from 'layout/Listing/store/useReturnPathStore';

import { hasArrayValues } from 'utils/array/arrays';
import { kebabToTitleCase } from 'utils/strings';

type BreadcrumbData = {
  id: string;
  label: string;
  link: string;
};

type ReplaceSlugList = {
  source: string;
  destination: string;
};

const replaceSlugList = [] as ReplaceSlugList[];

/**
 * Generates an array of breadcrumb data based on the provided pathname.
 *
 * @param pathname - The pathname to generate breadcrumb data for.
 * @param queryString - Optional query string to append on last breadcrumb.
 * @returns Array of breadcrumb data with id, label, and link.
 */
const generateBreadcrumbs = (pathname?: string, queryString?: string): BreadcrumbData[] => {
  const breadcrumbData: BreadcrumbData[] = [];
  const pathArray = pathname?.split('/').filter(Boolean) || [];

  pathArray.forEach((path: string, index: number) => {
    const label = kebabToTitleCase(path);

    const slugList = pathArray.slice(0, index + 1);

    const parsedSlugList = slugList.map(
      slug =>
        (hasArrayValues(replaceSlugList) &&
          replaceSlugList.find((listSlug: { source: string }) => listSlug.source === slug)?.destination) ||
        slug,
    );

    let link = `/${parsedSlugList.filter(Boolean).join('/')}`.replace(/\/{2,}/g, '/');

    if (index === 0) {
      const stored = useReturnPathStore.getState().getPath(link);
      if (stored) {
        link = stored;
      }
    }

    if (index === pathArray.length - 1 && queryString && !link.includes('?')) {
      link += `?${queryString}`;
    }

    breadcrumbData.push({
      id: `${path}-${index}`,
      label,
      link,
    });
  });

  return breadcrumbData;
};

export default generateBreadcrumbs;
